<main>
    <mat-card class="m-auto padding12 home-card boxshadowgrey">
        <div>
            <button mat-icon-button color="primary" class="back-button" routerLink="/machineState">
                <mat-icon>arrow_back</mat-icon>
            </button>
        </div>
        <div class="content">
        <div class="header">
            <h1>{{"MASCHINESTATE.JOYSTICK.HEADER" | translate}}</h1>            
        </div>

        <mat-card-content>
            <div class="home-card" id="content">
                <div class="container">
                    <!-- JOYSTICK HINTEN (links) -->
                    <div class="img-container joystick-wrapper">
                        <img class="img" src="../../../../../assets/images/joystick/Joystick_multi_hinten.PNG" alt=""/>

                        <!-- BUTTON Seite JoystickRightButtonS08 [9]-->
                        <div
                            class="button-highlight"
                            [class.active]="this.dataQueryList.dataPoints[9].value == 1"
                            style="top: 175px; left: 163px;"
                        ></div>

                        <!-- BUTTON hinten JoystickRightButtonS15 [11]-->
                        <div
                            class="button-highlight"
                            [class.active]="this.dataQueryList.dataPoints[11].value == 1"
                            style="top: 280px; left: 200px;"
                        ></div>

                        <!-- SLIDER  JoystickRightSliderBack [3]--> 
                        <div class="value-line" style="top: 215px; left: 240px; width: 60px;">
                            <div
                                class="value-marker"
                                [style.left.%]="this.dataQueryList.dataPoints[3].value"
                            ></div>
                            <div class="center-indicator"></div>
                        </div>
                    </div>
                    <!-- COORDINATES JOYSTICK -->
                    <div>
                        <div class="directions">                            
                            <app-two-directions-percentage-square-grid
                                [_x]="this.joystickDatasets[0].leftRight.value!"
                                [_y]="this.joystickDatasets[0].forwardBackward.value!"
                                [_dimension]="300"
                                class="joystick-component"
                                id="joystick"
                            ></app-two-directions-percentage-square-grid>
                        </div>
                    </div>
                    <!-- JOYSTICK VORNE (rechts) -->
                    <div class="img-container joystick-wrapper">
                        <img class="img" src="../../../../../assets/images/joystick/Joystick_multi_vorne.PNG" alt=""/>

                        <!-- BUTTON vorne links JoystickRightButtonS05 [6]-->
                        <div
                            class="button-highlight"
                            [class.active]="this.dataQueryList.dataPoints[6].value == 1"
                            style="top: 165px; left: 110px;"
                        ></div>
                        
                        <!-- BUTTON vorne rechts JoystickRightButtonS06 [7]-->
                        <div
                            class="button-highlight"
                            [class.active]="this.dataQueryList.dataPoints[7].value == 1"
                            style="top: 138px; left: 152px;"
                        ></div>

                        <!-- BUTTON seite oben JoystickRightButtonS07 [8]-->
                        <div
                            class="button-highlight"
                            [class.active]="this.dataQueryList.dataPoints[8].value == 1"
                            style="top: 162px; left: 12px;"
                        ></div>

                        <!-- BUTTON seite unten JoystickRightButtonS13 [10]-->
                        <div
                            class="button-highlight"
                            [class.active]="this.dataQueryList.dataPoints[10].value == 1"
                            style="top: 196px; left: 40px;"
                        ></div>

                        <!-- GEAR  JoystickRightGearSelection [12]-->
                        <div
                            class="button-highlight letter"
                            [class.active]="isActive"
                            style="top: 60px; left: 109px;"
                        > {{currentGear}}</div>

                        <!-- SLIDER  JoystickRightThumbWheel [2]-->
                        <div class="value-line rotated" style="top: 136px; left: 102px; width: 60px;">
                            <div
                                class="value-marker"
                                [style.left.%]="this.dataQueryList.dataPoints[2].value"
                            ></div>
                            <div class="center-indicator"></div>
                        </div>
                    </div>
                </div>
                <div class="fingertip-joystick-container">
                    <div class="fingertip-title">{{"MASCHINESTATE.JOYSTICK.FINGERTIP" | translate}}</div>
                    <div class="fingertip-content">
                        <!-- FINGERTIP JOYSTICK Up/Down  -->
                        <div class="fingertip joystick-wrapper">
                            <a class="header-fingertip">{{"MASCHINESTATE.JOYSTICK.VERTICAL" | translate}}</a>
                            <img class="img-fingertip" src="../../../../../assets/images/joystick/fingertip_joystick_multi_vertical.png" alt=""/>
                            <!-- SLIDER  Joystick Fingertip Up Down [4]--> 
                            <div class="value-line vertical" style="top: 75px; left: 30px; width: 60px;">
                                <div
                                    class="value-marker"
                                    [style.left.%]="this.dataQueryList.dataPoints[4].value"
                                ></div>
                                <div class="center-indicator"></div>
                            </div>
                        </div>
                        <!-- FINGERTIP JOYSTICK Left/Right  -->
                        <div class="fingertip joystick-wrapper">
                            <a class="header-fingertip">{{"MASCHINESTATE.JOYSTICK.HORIZONTAL" | translate}}</a>
                            <!-- SLIDER  Joystick Fingertip Left Right [5]--> 
                            <div class="value-line" style="top: 105px; left: 200px; width: 60px;">
                                <div
                                    class="value-marker"
                                    [style.left.%]="this.dataQueryList.dataPoints[5].value"
                                ></div>
                                <div class="center-indicator"></div>
                            </div>
                            <img class="img-fingertip" src="../../../../../assets/images/joystick/fingertip_joystick_multi_horizontal.png" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </div>
    </mat-card>
</main>
